interface ParsedTableData {
  headerList: string[]
  rowList: string[][]
}

const splitPipeRow = (line: string): string[] => {
  let inner = line.trim()
  if (inner.startsWith('|')) {
    inner = inner.slice(1)
  }
  if (inner.endsWith('|')) {
    inner = inner.slice(0, -1)
  }

  return inner.split('|').map((cell) => cell.trim())
}

const isSeparatorLine = (line: string): boolean => /^[\s|:-]+$/.test(line) && line.includes('-')

export const parsePipeTable = (text: string): ParsedTableData | null => {
  const lineList = text
    .split('\n')
    .map((l) => l.trim())
    .filter((l) => l.length > 0)

  if (lineList.length < 2) {
    return null
  }

  const firstDataIndex = isSeparatorLine(lineList[1]) ? 2 : 1
  const headerList = splitPipeRow(lineList[0])

  if (headerList.length < 2) {
    return null
  }

  const rowList: string[][] = []
  for (let i = firstDataIndex; i < lineList.length; i++) {
    if (isSeparatorLine(lineList[i])) {
      continue
    }
    const cellList = splitPipeRow(lineList[i])
    rowList.push(cellList)
  }

  return { headerList, rowList }
}
